import { useLayoutEffect, useRef } from "react";

import { gsap } from "gsap";

import "./style.scss";

const CarModel = () => {
	const modelRef = useRef<HTMLDivElement | null>(null);
	const scrollTriggerRef = useRef<HTMLDivElement | null>(null);
	useLayoutEffect(() => {
		if (typeof window === "undefined") return;

		if (!modelRef.current || !scrollTriggerRef.current) return;

		const gsapMatchMedia = gsap.matchMedia();
		const initScrollTrigger = () => {
			gsapMatchMedia.add(
				{ isMobile: "(max-width: 768px)", isDesktop: "(min-width: 769px)" },
				(context) => {
					const { isMobile } = context.conditions!;
					const sectionEl = scrollTriggerRef.current?.closest(
						".tech-intro-section_2",
					) as HTMLElement | null;
					if (!sectionEl) return;

					// Plan A: Outer pin (애니 + 대기) & Inner scrub (애니만)
					const animDist = Math.round(window.innerHeight * (isMobile ? 1.2 : 1.7));

					// Inner animation: 애니 구간만 스크럽
					const tl = gsap.timeline({
						defaults: { ease: "none" },
						scrollTrigger: {
							trigger: sectionEl,
							start: "top top",
							end: `+=${animDist}`,
							pin: sectionEl,
							pinSpacing: true,
							scrub: 1.5,
							invalidateOnRefresh: true,
							endTrigger: ".end-trigger-2",
						},
					});

					// 1) 차가 작게 시작해서 앞으로 다가오며 위치 조정
					const setting = isMobile
						? {
								startScale: 0.3,
								endScale: 2.2,
								startYPercent: 80,
								endYPercent: 220,
							}
						: {
								startScale: 0.1,
								endScale: 1.2,
								startYPercent: 10,
								endYPercent: 49,
							};
					tl.fromTo(
						modelRef.current,
						{ scale: setting.startScale, yPercent: setting.startYPercent },
						{
							scale: setting.endScale,
							yPercent: setting.endYPercent,
						},
					);

					// 2) 이동 중 창문 노출 (이동과 동시에 시작)
					tl.fromTo(
						".section-car-model__front-window",
						{ opacity: 0 },
						{ opacity: 0.8 },
						">",
					);
					tl.to({}, { duration: 1 });
				},
			);
		};
		initScrollTrigger();

		return () => {
			gsapMatchMedia.revert();
		};
	}, []);

	return (
		<div className="car-model-container end-trigger" ref={scrollTriggerRef}>
			<div className="car-model" ref={modelRef}>
				<img
					className="car-model__car"
					src="/images/main/car-2/car.webp"
					alt="Car Object"
				/>
				<img
					className="section-car-model__front-window"
					src="/images/main/car-2/front-window.webp"
					alt="Front Window Object"
				/>
			</div>
		</div>
	);
};

export default CarModel;
